export class CoordonneesUtil {
  static supprimerEspace(string: string): string {
    return string?.replace(/ /g, '');
  }

  static removeDoubleSpace(string: string): string {
    return string?.replace(/\s+/g, ' ');
  }

  static separerNumeroCiviqueEtNomRue(numeroCiviqueNomRue: string): { numeroCivique: string; nomRue: string } {
    const separation = (numeroCiviqueNomRue ?? '').trim().split(/\s+/);
    return {
      numeroCivique: separation[0],
      nomRue: separation.slice(1).join(' '),
    };
  }
}
